'use client'

import Button from "@/components/button/Button";
import Field from "@/components/form/Field";
import Form from "@/components/form/Form";
import Icon from "@/components/icon/Icon";
import Modal from "@/components/modal/Modal";
import PanelBody from "@/components/panel/PanelBody";
import PanelHeader from "@/components/panel/PanelHeader";
import PanelTitle from "@/components/panel/PanelTitle";
import StackedPanel from "@/components/panel/StackedPanel";
import ApiUtils from "@/utils/ApiUtils";
import { useRouter } from "next/navigation";
import OTPConfirmationForm from "./OTPConfirmationForm";
import LeadForm from "../lead/LeadForm";
import styles from "./ua.module.scss";

const { forwardRef, useImperativeHandle, useRef, useState } = require("react");

const LeadPopup = forwardRef((props, ref) => {
  
  const router = useRouter()
  
  const modal = useRef()
  const [params,setParams] = useState()
  
  const show = (params) => {
    setParams(params)
    modal.current.show()
  }
  
  const hide = (e) => {
    modal.current.hide()
  }
  
  const onSubmit = (data) => {
    if (props.onSubmit) props.onSubmit(data)
    hide()
  }
  
  useImperativeHandle(ref, () => ({
    show, hide
  }))
  
  return <Modal ref={modal}>
    <StackedPanel className={styles.panel}>
      <PanelHeader>
        <PanelTitle leftPad={true} centered={true}>
          <h2>{ props.config?.title || 'Your Information' }</h2>
        </PanelTitle>
        <div>
          <Button theme={'icon'} onClick={e => hide(e)} label={ 'Close' }>
            <span className="ico-smaller"><Icon {...props} name="x"></Icon></span>
          </Button>
        </div>
      </PanelHeader>
      <PanelBody padded={true}>
        { props.config?.message &&
        <section>
          <h3>{ props.config?.message }</h3>
        </section>
        }
        <section>
          <LeadForm ctx={'popup'} {...props} size="50" refData={params} vehicle={props.vehicle} abData={props.abTag ? { keyword: 'position-' + props.abTag } : null} onSubmit={data => onSubmit(data)}></LeadForm>
        </section>
      </PanelBody>
    </StackedPanel>
  </Modal>
  
})

LeadPopup.displayName = "LeadPopup";
export default LeadPopup;